import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import UserList from './user-list';
import PageHeader from '@/components/PageHeader';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Users">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>            
            <Breadcrumb.Item active>Users</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <UserList />
    </Panel>
  );
};

export default Page;
